import { zExt } from "@redotech/rpc/ext";
import { z } from "zod";
export const getSubmissionWorkflowStatus = {
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({
    finished: z.boolean(),
    noWorkflow: z.boolean().nullish(),
  }),
};
